import { render, staticRenderFns } from "./buttons-common.vue?vue&type=template&id=643fd9d2&scoped=true&"
import script from "./buttons-common.vue?vue&type=script&lang=js&"
export * from "./buttons-common.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643fd9d2",
  null
  
)

export default component.exports